import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { mergeWith } from '@chakra-ui/utils';
import Button from './button.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['container', 'list', 'listItem', 'item', 'ellipsis', 'arrow'];
var baseStyleContainer = {
  // Lobotomized owl selector
  // Used in `<Stack />` as well.
  '& > *:not(style)~*:not(style)': {
    ml: 1
  },
  mb: -1,
  listStyle: 'none',
  display: 'flex'
};
var baseStyleList = {
  // Lobotomized owl selector
  // Used in `<Stack />` as well.
  '& > *:not(style)~*:not(style)': {
    ml: 1
  },
  listStyle: 'none',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center'
};
var baseStyleListItem = {
  display: 'flex',
  mb: 1
};
var baseStyleItem = function baseStyleItem(props) {
  var c = props.colorScheme,
    theme = props.theme;
  var buttonBaseStyle = Button.baseStyle(props);
  var buttonVariantSecondary = Button.variants.inverted({
    colorScheme: 'gray',
    theme: theme
  });
  var buttonVariantSolid = Button.variants.solid({
    colorScheme: c,
    theme: theme
  }); // The spreading here is a bit excessive, but it's the only way to make it work
  // with an uncontrolled (button) and controlled (a) component.

  return _objectSpread(_objectSpread(_objectSpread({
    display: 'flex'
  }, buttonBaseStyle), buttonVariantSecondary), {}, {
    _disabled: _objectSpread(_objectSpread(_objectSpread({}, buttonBaseStyle._disabled), buttonVariantSecondary._disabled), {}, {
      _focus: _objectSpread({}, buttonVariantSecondary._disabled)
    }),
    _activeStep: mergeWith(buttonVariantSolid, {
      _hover: {
        color: 'white'
      },
      _disabled: {
        _focus: {
          color: 'white'
        }
      }
    })
  });
};
var baseStyleEllipsis = {
  cursor: 'default',
  color: 'gray.400'
};
var baseStyleArrow = function baseStyleArrow(props) {
  var c = props.colorScheme,
    theme = props.theme;
  var buttonBaseStyle = Button.baseStyle(props);
  var buttonVariantGhost = Button.variants.ghost({
    colorScheme: c,
    theme: theme
  });
  return _objectSpread(_objectSpread(_objectSpread({}, buttonBaseStyle), buttonVariantGhost), {}, {
    _disabled: _objectSpread(_objectSpread(_objectSpread({}, buttonBaseStyle._disabled), buttonVariantGhost._disabled), {}, {
      // This disables links as well. The reason for this is so when you're at
      // the first or last page and want to go previous or next respectively,
      // it will not do anything, as the `arrow` is disabled if that's the case.
      pointerEvents: 'none'
    }),
    mb: 1
  });
};
var baseStyle = function baseStyle(props) {
  return {
    container: baseStyleContainer,
    list: baseStyleList,
    listItem: baseStyleListItem,
    item: baseStyleItem(props),
    arrow: baseStyleArrow(props),
    ellipsis: baseStyleEllipsis
  };
};
var sizes = {
  sm: {
    item: Button.sizes.sm,
    arrow: Button.sizes.sm,
    ellipsis: Button.sizes.sm
  },
  md: {
    item: Button.sizes.md,
    arrow: Button.sizes.md,
    ellipsis: Button.sizes.md
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
var Pagination = {
  parts: parts,
  sizes: sizes,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
export { Pagination as default };